import { Navigate, useParams } from "react-router-dom";

const ShareMeasurementsLanding = () => {
    const { measurementIds } = useParams();
    
    return <Navigate to={`/measurements/${measurementIds}`} replace />;
};

export default ShareMeasurementsLanding;
